<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    :width="width"
    :height="height"
    viewBox="0 0 64 64"
  >
    <g fill="none" fill-rule="evenodd">
      <g fill-rule="nonzero">
        <g>
          <g>
            <g>
              <g>
                <path
                  fill="#002B64"
                  d="M62.596.001c-.99.032-.677.317-2.814.843-2.158.53-4.794.368-7.118 1.342-6.938 2.91-8.33 12.854-14.637 16.417-4.714 2.662-9.47 2.875-13.746 4.215-2.81.88-5.885 2.688-8.43 4.882-1.977 1.704-2.029 3.202-4.094 5.339-2.208 2.285-8.778.038-11.755 3.537.959.97 1.38 1.241 3.27.99-.392.741-2.699 1.366-2.247 2.457.475 1.148 6.052 1.927 11.122-1.134 2.36-1.426 4.242-3.48 7.918-3.97 4.759-.635 10.24.406 15.75 1.2-.818 2.436-2.458 4.056-3.771 5.995-.407.438.817.487 2.213.223 2.512-.621 4.322-1.122 6.217-2.225 2.329-1.355 2.682-4.83 5.539-5.583 1.592 2.447 5.922 3.025 8.608 1.068-2.357-.668-3.009-5.686-2.213-7.897.754-2.093 1.499-5.44 2.258-8.208.815-2.971 1.115-6.716 2.102-8.23 1.484-2.277 3.123-3.06 4.547-4.343 1.424-1.284 2.727-2.534 2.684-5.473C63.985.5 63.496-.028 62.596.001z"
                  transform="translate(-403 -674) translate(350 416) translate(0 226) translate(53 32) translate(0 12)"
                />
                <path
                  fill="#FFF"
                  d="M2.05 39.814c3.61.517 5.805 0 8.704-1.257 2.467-1.07 4.85-3.276 7.763-4.21 4.278-1.373 8.97.001 13.543.275 1.113.067 2.22.068 3.312-.051 1.704-1.047 1.669-4.964 3.327-5.323-.05 5.495-2.302 8.788-4.658 11.976 4.966-.877 7.937-3.749 9.944-7.585.609-1.163 1.129-2.414 1.589-3.726.71.546.308 2.206.665 3.105 3.42-1.905 5.378-6.253 6.676-10.65 1.5-5.09 2.114-10.244 3.082-11.75.944-1.47 2.414-2.375 3.756-3.316 1.525-1.07 2.885-2.185 3.12-4.224-1.608-.149-1.98-.52-2.218-1.331-.805.454-1.545.55-2.382.576-.725.022-1.523-.01-2.496.09-8.053.827-9.077 9.703-14.238 14.734-.38.369-.785.712-1.21 1.028-1.809 1.347-4.026 2.31-6.066 3.089-3.3 1.261-6.439 1.35-9.536 2.44-2.273.799-4.584 1.958-6.45 3.236-.452.307-.89.633-1.313.977-1.095.897-1.815 1.891-2.51 2.915-.718 1.054-1.41 2.139-2.467 3.175-1.711 1.68-8.105.49-10.357 2.049-.25.173-.45.381-.585.63 1.228.56 2.048.217 3.461.373.186 1.34-2.915 2.137-2.457 2.755zm48.788-9.66c.096 1.539.989 4.59 1.777 5.333-1.544.375-4.203-.245-4.886-1.334.35-1.573 2.175-3.01 3.109-3.998z"
                  transform="translate(-403 -674) translate(350 416) translate(0 226) translate(53 32) translate(0 12)"
                />
                <path
                  fill="#002B64"
                  d="M53.1 5.743c1.14.99 3.531.195 3.104-1.774-1.771-.147-2.797.455-3.104 1.774zm7.947-2.301c-.303.636-.884 1.456-.884 3.074-.002.278-.21.469-.214.04.016-1.582.434-2.266.88-3.165.206-.368.33-.216.218.05z"
                  transform="translate(-403 -674) translate(350 416) translate(0 226) translate(53 32) translate(0 12)"
                />
                <path
                  fill="#002B64"
                  d="M60.742 3.202c-.358.607-1.22 1.714-1.362 3.327-.026.276-.25.447-.217.02.156-1.575.844-2.56 1.366-3.417.237-.348.349-.186.213.07zm-.279-.317c-.407.574-1.733 1.903-2.01 3.499-.05.273-.288.425-.218.002.287-1.556 1.43-2.78 2.022-3.589.265-.328.363-.156.206.088zm-.248-.354c-.484.51-2.065 2.206-2.563 3.747-.088.263-.345.38-.216-.029.502-1.5 1.887-3.117 2.587-3.834.31-.287.381-.104.192.116z"
                  transform="translate(-403 -674) translate(350 416) translate(0 226) translate(53 32) translate(0 12)"
                />
              </g>
            </g>
          </g>
        </g>
      </g>
    </g>
  </svg>
</template>

<script>
import VueTypes from 'vue-types';
export default {
  name: 'MariaDBLogoIcon',
  props: {
    height: VueTypes.string.def('32'),
    width: VueTypes.string.def('32'),
  },
};
</script>

<style lang="scss"></style>
